import React from "react";
import numeral from "numeral";

class PropertyCalendarRoomTypeCell extends React.Component {
  constructor(props) {
    super(props);

    this.onExpandCollapse = this.onExpandCollapse.bind(this);
  }

  render() {
    return (
      <div
        className="PropertyCalendarRoomTypeCell"
        style={this.generateStyle()}
      >
        {this.renderCode()}
        {this.renderAmount()}
        {this.renderAvailability()}
      </div>
    );
  }

  renderAmount() {
    if (this.props.amount) {
      return (
        <span className="amount">
          <sup>{I18n.t("number.currency.format.unit")}</sup>
          {numeral(this.props.amount / 100).format("0,000")}
        </span>
      );
    }
  }

  renderAvailability() {
    // if (this.props.room_type_id == "7a553eec-27da-4645-8a82-e878c9eb9103") {
    //   console.log('this.props', this.props);
    // }
    var self = this;
    if (
      typeof self.props.rooms_available != "undefined" &&
      typeof self.props.total_rooms != "undefined"
    ) {
      var href = `/admin/dashboard/room_type/${this.props.room_type_id}/date/${this.props.date}`;
      if (self.props.rooms_available != this.props.total_rooms) {
        let title = I18n.t("rooms_available");
        return (
          <a
            className={
              self.props.unassigned_rooms || self.props.rooms_available < 0
                ? "modal-iframe badge bg-primary"
                : "modal-iframe badge bg-secondary"
            }
            style={{ display: "inline" }}
            data-fullscreen="true"
            data-nested="true"
            href={href}
            title={title}
          >
            <span>
              {self.props.rooms_available}/{self.props.total_rooms}
            </span>
          </a>
        );
      } else {
        return (
          <span
            className={
              self.props.unassigned_rooms || self.props.rooms_available < 0
                ? "badge bg-primary"
                : "badge bg-secondary"
            }
            title={I18n.t("rooms_available")}
          >
            {self.props.rooms_available}/{self.props.total_rooms}
          </span>
        );
      }
    }
  }

  renderCode() {
    if (this.props.room_type) {
      return (
        <div className="code" onClick={this.onExpandCollapse}>
          {this.props.room_type.collapsed ? (
            <span className="expand-collapse">&#9656;</span>
          ) : (
            <span className="expand-collapse">&#9662;</span>
          )}
          {this.props.room_type.status == "disabled" ? (
            <span style={{ color: "grey" }}>
              {this.props.room_type.code}
              <span
                className="ss-alert alert"
                title={I18n.t("status_is_disabled")}
              ></span>
            </span>
          ) : (
            <span>{this.props.room_type.code}</span>
          )}
        </div>
      );
    }
  }

  onExpandCollapse() {
    this.props.onExpandCollapseRoomType(
      this.props.room_type,
      this.props.room_type.collapsed ? false : true
    );
  }

  generateStyle() {
    if (
      typeof this.props.top != "undefined" &&
      typeof this.props.left != "undefined"
    ) {
      return { top: this.props.top + "px", left: this.props.left + "px" };
    } else {
      return { top: this.props.top + "px" };
    }
  }
}

export default PropertyCalendarRoomTypeCell;
